import { PROTOCOL_TYPE } from './protocols.consts'
import { getAcceptanceDeliveryProtocol } from './protocols.hook'

export function getProtocols(protocol: any) {
  const { acceptanceDeliveryList } = getAcceptanceDeliveryProtocol(Number(protocol?.leaseContract))

  const [acceptanceProtocol, deliveryProtocol] = acceptanceDeliveryList
    ? [
        acceptanceDeliveryList.find((item) => item.protocolType === PROTOCOL_TYPE.acceptance),
        acceptanceDeliveryList.find((item) => item.protocolType === PROTOCOL_TYPE.delivery)
      ]
    : [undefined, undefined]

  const currentProtocol =
    protocol?.protocolType === PROTOCOL_TYPE.acceptance ? acceptanceProtocol : deliveryProtocol

  const oppositeProtocol =
    protocol?.protocolType === PROTOCOL_TYPE.acceptance ? deliveryProtocol : acceptanceProtocol

  return { currentProtocol, oppositeProtocol }
}

/**
 * Formats flat number for display:
 * - If the flat is purely numeric (e.g., "007"), converts to number to remove leading zeros
 * - If the flat contains letters (e.g., "A001"), keeps the original string format
 */
export function formatFlatNumber(flat: string | null): string | number {
  if (!flat) return ''
  return isNaN(Number(flat)) ? flat : +flat
}
